import { createActionFactory, HubPersonaType, Feature } from '../../../shared';
import type { Dispatch } from 'redux';

export { PersonType } from '../../../shared';

export type NewPersonaOrigin = 'commandBar' | 'emptyContact' | 'leftNav';

export const newPersonaClickedAction = createActionFactory<{
    hubPersonaType: HubPersonaType;
    origin: NewPersonaOrigin;
}>('NewPersonaClickedAction', Feature.ContactManagement);

export const newPersonaClicked = (dispatch: Dispatch) => (
    hubPersonaType: HubPersonaType,
    origin: NewPersonaOrigin
) =>
    dispatch(
        newPersonaClickedAction({
            hubPersonaType,
            origin,
        })
    );
export type { Action } from '../../../shared';
